import React from "react";
import "../components/ReportModall.css";
import "../articlesblogs/FilterBlog.css";
// Import SVG

const PauseTestQuizModal = ({ open, onClose, onPause, description, isPausing = false }) => {
  if (!open) return null;

  const closeAll = () => {
    onClose();
  };

  return (
    <>
     <style>{`
      .unlockModal .confirm-btn {
          background: #4d1fe0!important;
      }
     .pause-bg{
        background: #f6f4ff;
      }
      .modal-text{
        color:#9a9a9a;
        font-size: 15px;
      }
`}</style>

    <div className="modal-overlay resetModal unlockModal delModal" onClick={isPausing ? undefined : onClose}>
      <div
        className="modal-container text-center rounded-4"
        onClick={(event) => event.stopPropagation()}
      >
        {/* Close Button */}
           <div className="close-btn2 text-end unlock-close-btn">
              <button
                type="button"
                className="btn-close"
                onClick={closeAll}
                aria-label="Close"
              > </button>
            </div>
        {/* Icon */}
        <div className="premium-icon delete-trash pause-bg">
           <span className="modal-icon">
            <div className="pause-icon">
              <div className="pause-bars" />
            </div>
           </span>
        </div>

        {/* Title */}
        <h5 className="fw-bold blackText mb-2">
           Are you sure you want to Pause the Test/Quiz?
        </h5>

        {/* Description */}
        <p className="modal-text">
       {description ||
            "You can resume from where you left off at any time. Your progress will remain saved."}
        </p>

        <div className="filter-blog-modal__footer">
          <button type="button" className="filter-blog-modal__action delete-close"   onClick={onClose}
            disabled={isPausing} >
            <span>Cancel</span>
          </button>
         <button
            type="button"
            className="filter-blog-modal__action confirm-btn purple-button"
            onClick={onPause}
            disabled={isPausing}
          >
            {isPausing ? "Pausing..." : "Pause"}
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default PauseTestQuizModal;
